import { render, staticRenderFns } from "./Alternativas.vue?vue&type=template&id=70971222&scoped=true"
import script from "./Alternativas.vue?vue&type=script&lang=js"
export * from "./Alternativas.vue?vue&type=script&lang=js"
import style0 from "./Alternativas.vue?vue&type=style&index=0&id=70971222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70971222",
  null
  
)

export default component.exports